<script lang="ts" setup>
import type { SearchProductItem } from '../../domain/search-product.model.js';

defineProps<{ card: SearchProductItem; isActive: boolean }>();
const emit = defineEmits(['card-picked']);
</script>

<template>
  <label class="configurator-pick-a-card_option" @change="emit('card-picked')" style="position: relative">
    <input type="radio" name="configurator-card" :value="card.id" :checked="isActive" />

    <img :src="card.featured_image" :alt="card.title" />

    <span class="search-item__product-title">{{ card.title }}</span>
  </label>
</template>
